module.exports = __webpack_public_path__ + "img/36047e4.png";